module.exports = __webpack_public_path__ + "static/media/contacto.7ba0897b.jpg";